import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {defaultState} from '../reducers/entity';
import DogForm from '../components/dog/DogForm';
import {breadcrumbs} from "../utils";
import {AnimalKind, BaseStatus, DogVariant} from "../utils/enums";

class DogEditPage extends Component {

	render() {
		const {match: {params}, entity} = this.props;

		const bc = [
			{url: '/psi', title: 'Psi'}
		];
		if (params.dogId) {
			bc.push({url: '/psi/' + params.dogId, title: entity && entity.item && entity.item.dogId ? entity.item.name : '...', literal: true});
			bc.push({url: '/psi/' + params.dogId + '/uprava', title: 'Úprava'});
		} else {
			bc.push({url: '/psi/novy', title: 'Nový'});
		}

		return (
			<div>
				<Row>
					<Col xs={12}>
						{breadcrumbs(bc)}
					</Col>
				</Row>
				<DogForm
					variant={DogVariant.DOG}
					form={'dog-' + DogVariant.DOG}
					dog={{
						dogId: params.dogId,
						animalKind: AnimalKind.DOG,
						status: BaseStatus.ACTIVE
					}}
					onSave={(dog) => {
						this.props.history.push('/psi/' + dog.dogId)
					}}/>
			</div>
		)
	}
}

DogEditPage.propTypes = {
	entity: PropTypes.object.isRequired,
};


const mapStateToProps = (state, ownProps) => {
	const {
		entities: {dogs},
	} = state;

	const dogId = ownProps.match.params.dogId;
	const entity = dogs && dogs[dogId]
		? dogs[dogId]
		: {...defaultState, item: {}}

	return {
		entity
	}
};

export default connect(mapStateToProps, {})(DogEditPage)



// WEBPACK FOOTER //
// ./src/containers/DogEditPage.js